import { supertypeClass, property, Persistable, Remoteable, Supertype } from '@haventech/amorphic';
import { Party } from './Party';
import { Person } from './Person';
import { Customer } from './Customer';

@supertypeClass({ toClient: true, toServer: true })
export class PartyRelation extends Persistable(Remoteable(Supertype)) {
  @property()
  description: string;

  @property({
    getType: () => Party,
    comment: `the party that owns the relationship.
        for example, if representing insured's family members,
        insured would be source, and each family member would be target`,
  })
  source: Party;

  @property({
    getType: () => Party,
    comment: `the party that is the target of the relationship.
        for example, if representing insured's family members,
        insured would be source, and each family member would be target`,
  })
  target: Party;

  constructor() {
    super();
  }

  static new(customer: Customer): PartyRelation {
    return new PartyRelation().init(customer);
  }

  init(customer: Customer): this {
    this.target = Person.new(customer);
    return this;
  }
}
